import React, { useEffect } from "react";
import { Box, Grid, Typography } from "@mui/material";
import { getIcon } from "utils/iconsConfig";
import Modal from "../Modal";
import { formatDate } from "utils/formatDate";
import "./StockInfoModalstyle.css";
import SaleDetailsModal from "../SaleDetailsModal/SaleDetailsModal";
import { findSpecificMenu, findSpecificSubMenu, isAllowed } from "utils/checkUserRigths";
import { usePermissions } from "context/PermissionsContext";

const StockInfoBox = ({ open, setOpen, stockInfo, setStockInfo }) => {
  const [salesDetailsModal, setSaleDetailModal] = React.useState(false);
  const permission = usePermissions();
  const handleClose = () => {
    setOpen(false);
  };
  const SalesByyearAccess = isAllowed(findSpecificSubMenu(findSpecificMenu("Vision Web", permission), "Sales By year"), "view");
  const SalesByClientAccess = isAllowed(findSpecificSubMenu(findSpecificMenu("Vision Web", permission), "Sales By Client"), "view");
  const getTrophyIcon = (trophy) => {
    const trophyMap = {
      Gold: "gold_cup",
      Silver: "silver_cup",
      Bronze: "bronze_cup",
    };
    return trophyMap[trophy] || "default_icon";
  };

  useEffect(() => {
    return () => {
      if (!open && stockInfo) {
        setStockInfo(null);
      }
    };
  }, [open, stockInfo]);

  if (!stockInfo) {
    return null;
  }

  return (
    <Modal open={open} handleClose={handleClose} style={{ width: "400px" }}>
      <Box display="flex" justifyContent="space-between" alignItems="center">
        <Typography variant="h6" fontWeight="500" sx={{ fontSize: "24px", fontFamily: "Poppins" }}>
          Information
        </Typography>
        {(SalesByyearAccess || SalesByClientAccess) && (
          <Box onClick={() => setSaleDetailModal(true)} sx={{ cursor: "pointer", display: "flex", alignItems: "center" }}>
            {getIcon("date", "black")}
          </Box>
        )}
      </Box>

      <Grid container spacing={2} sx={{ marginTop: 1 }}>
        {(SalesByyearAccess || SalesByClientAccess) && (
          <Grid item xs={6}>
            <Box display="flex" alignItems="center" gap={1}>
              {getIcon("lightsales", "black")}
              <Typography className="stock-main-title">Sales</Typography>
            </Box>
          </Grid>
        )}
        {(SalesByyearAccess || SalesByClientAccess) && (
          <Grid item xs={6} textAlign="right">
            <Typography className="stock-sub-title">{stockInfo?.sales}</Typography>
          </Grid>
        )}
        <Grid item xs={6}>
          <Box display="flex" alignItems="center" gap={1}>
            {getIcon("lightdate", "black")}
            <Typography className="stock-main-title">Make Date</Typography>
          </Box>
        </Grid>
        <Grid item xs={6} textAlign="right">
          <Typography className="stock-sub-title">{formatDate(stockInfo?.makeDate)}</Typography>
        </Grid>

        <Grid item xs={6}>
          <Box display="flex" alignItems="center" gap={1}>
            {getIcon("lightdate", "black")}
            <Typography className="stock-main-title">Design Date</Typography>
          </Box>
        </Grid>
        <Grid item xs={6} textAlign="right">
          <Typography className="stock-sub-title">{formatDate(stockInfo?.designDate)}</Typography>
        </Grid>
        <Grid item xs={6}>
          <Box display="flex" alignItems="center" gap={1}>
            {getIcon("maketype", "black")}
            <Typography className="stock-main-title">Make Type</Typography>
          </Box>
        </Grid>
        <Grid item xs={6} textAlign="right">
          <Typography fontWeight="700" sx={{ fontSize: "15px" }}>
            {getIcon(stockInfo?.makeType, "black")}
          </Typography>
        </Grid>
      </Grid>

      {/* {stockInfo?.tableData && stockInfo?.tableData.length > 0 && ( */}
      {stockInfo?.tableData?.length > 0 && (
        <Box display="flex" justifyContent="space-between" alignItems="center" sx={{ marginTop: 3 }}>
          <Typography variant="h6" fontWeight="500" sx={{ fontSize: "24px", fontFamily: "Poppins" }}>
            Highest Seller
          </Typography>
          <Typography fontWeight="500" sx={{ fontSize: "22px", fontFamily: "Karla" }}>
            {stockInfo?.highestSeller}
          </Typography>
        </Box>
      )}

      {stockInfo?.tableData?.length > 0 && (
        <Box sx={{ marginTop: 1, borderRadius: 1, border: "1px solid #ccc", overflow: "hidden" }}>
          <Grid container sx={{ fontWeight: "bold", padding: 0, borderBottom: "1px solid #ccc", textAlign: "center" }}>
            <Grid item xs={4} sx={{ borderRight: "1px solid #ccc", padding: "6px 0" }}>
              <Typography className="stock-table-header">Rank</Typography>
            </Grid>
            <Grid item xs={4} sx={{ borderRight: "1px solid #ccc", padding: "6px 0" }}>
              <Typography className="stock-table-header">Year</Typography>
            </Grid>
            <Grid item xs={4} sx={{ padding: "6px 0" }}>
              <Typography className="stock-table-header">Sales</Typography>
            </Grid>
          </Grid>

          {stockInfo?.tableData?.length > 0 ? (
            stockInfo.tableData.map((item, index) => (
              <Grid container key={index} sx={{ borderBottom: index !== stockInfo.tableData.length - 1 ? "1px solid #ccc" : "none", textAlign: "center" }}>
                <Grid item xs={4} sx={{ borderRight: "1px solid #ccc", padding: 0.5 }}>
                  {getIcon(getTrophyIcon(item.trophy), "black")}
                </Grid>
                <Grid item xs={4} sx={{ borderRight: "1px solid #ccc", padding: 0.5 }}>
                  <Typography className="stock-table-data">{item.year}</Typography>
                </Grid>
                <Grid item xs={4} sx={{ padding: 0.5 }}>
                  <Typography className="stock-table-data">{item.sales}</Typography>
                </Grid>
              </Grid>
            ))
          ) : (
            <Typography sx={{ textAlign: "center", padding: "10px", fontSize: "16px", color: "gray" }}>No Data available</Typography>
          )}
        </Box>
      )}
      <SaleDetailsModal open={salesDetailsModal} setOpen={setSaleDetailModal} styleNumber={stockInfo?.highestSeller} type="Design" fromStockInfo={true} />
    </Modal>
  );
};

export default StockInfoBox;
